import useErrorField from '@package/hooks/src/useErrorField';
import { FieldProps } from 'formik';

import TextField from '../TextField';

import { FormTextFieldProps } from './types';

const FormTextField = (props: FormTextFieldProps & FieldProps) => {
  const { field, form, ...rest } = props;
  const { error, helperText } = useErrorField(form.errors[field.name] as string, form.touched[field.name] as boolean);

  return <TextField error={error} helperText={helperText} {...field} {...rest} value={field.value || ''} />;
};

export default FormTextField;
